import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  listTreatmentPlanDetails,
  updateTreatmentPlan,
  downloadTreatmentPlanPdf,
} from "../../../../actions/treatmentPlanActions";
import {
  Button,
  Flex,
  Text,
  Spinner,
  Box,
  Heading,
  Image,
  useToast,
  IconButton,
  Icon,
  Tooltip,
  Stack,
} from "@chakra-ui/react";
import {
  primary,
  white,
  textPrimary,
  textSecondary,
  buttonRedText,
  buttonRed,
  primaryAlt,
  greenVivid,
  whiteAlt,
  color3,
  color6,
  color8,
  backgroundLight,
} from "../../../../utils/colors";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import mongoose from "mongoose";
import noServices from "../../../../assets/images/empty-box.png";
// import blank from "../../../../assets/icons/blank.svg";
import ServiceListNew from "../../../../components/partials/ServiceListNew";
import {
  FaArrowLeftLong,
  FaCircleCheck,
  FaCircleXmark,
  FaEnvelope,
  FaFilePdf,
  FaXmark,
} from "react-icons/fa6";
import UserSelectButton from "../../../../components/buttons/UserSelectButton";
import { TbDiscount, TbDiscount2, TbSwitch } from "react-icons/tb";
import AddServiceModal from "../../../../components/modals/AddServiceModal";
import AddCoordinatorModal from "../../../../components/modals/AddCoordinatorModal";
// import SendTreatmentPlanModal from "../../../../components/modals/SendTreatmentPlanModal";
import SendTreatmentPlanModalNew from "../../../../components/modals/SendTreatmentPlanModalNew";
import useThemeColors from "../../../../hooks/useThemeColors";
import StatusButtonTreatmentPlanEdit from "../../../../components/buttons/StatusButtonTreatmentPlanEdit";
import AddServiceButton from "../partials/AddServiceButton";
// import FormControlTextArea from "../../../../components/input/FormControlTextArea";
import TreatmentPlanPatientNotes from "./partials/TreatmentPlanPatientNotes";
import { useParams } from "react-router-dom";
import useCurrencySymbol from "../../../../hooks/useCurrencySymbol";
import useIsMobile from "../../../../hooks/useIsMobile";
import WarningModal from "../../../../components/buttons/partials/WarningModal";
import ServiceListNewMobile from "../../../../components/partials/ServiceListNewMobile";
import { MdLocalHospital } from "react-icons/md";

const EditTreatmentPlanNewNew = ({
  hasEditAccess,
  planId,
  close,
  currentUser,
  currency,
  hasAccessSendToPatient,
}) => {
  // GENERAL
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const toast = useToast();
  const isMobile = useIsMobile();

  // COLORS
  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  // PDF

  const [isAdvancedMode, setIsAdvancedMode] = useState(
    localStorage.getItem("isAdvancedMode") === "false"
  );

  // STATE
  const [isModalSending, setIsModalSending] = useState(false);
  const [fetchUnavailable, setFetchUnavailable] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(today);
  const [patient, setPatient] = useState({});
  const [employee, setEmployee] = useState(currentUser._id);
  const [status, setStatus] = useState("");
  const [coordinator, setCoordinator] = useState("");
  const [services, setServices] = useState([]);
  const [totalTpPrice, setTotalTpPrice] = useState(0);
  const [loadingDisplay, setLoadingDisplay] = useState(true);
  const [notes, setNotes] = useState("");
  const [draftNote, setDraftNote] = useState("");

  const [addServiceModalOpen, setAddServiceModalOpen] = useState(false);
  const [addPatientModalOpen, setAddPatientModalOpen] = useState(false);
  const [addCoordinatorModalOpen, setAddCoordinatorModalOpen] = useState(false);

  const [sendEmailModalOpen, setSendEmailModalOpen] = useState(false);

  const [oneLeftToComplete, setOneLeftToComplete] = useState(false);
  const [oneLeftToUncomplete, setOneLeftToUncomplete] = useState(false);

  const [initialPlan, setInitialPlan] = useState(null);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);

  // Toggle Advanced Mode and save to local storage
  const toggleAdvancedMode = () => {
    const newMode = !isAdvancedMode;
    setIsAdvancedMode(newMode);
    localStorage.setItem("isAdvancedMode", newMode);
  };

  const [isServicesValid, setIsServicesValid] = useState(true);
  const isServicesSelected = services.length > 0;
  const isPatientSelected = patient !== null;
  const isCoordinatorSelected = coordinator !== null;

  // LANGUAGE
  const storedLanguage = localStorage.getItem("language");
  const initialLanguage = storedLanguage || "en"; // Default to 'en'
  const [currentLanguage, setCurrentLanguage] = useState(initialLanguage);

  // REDUX

  const treatmentPlanDetails = useSelector(
    (state) => state.treatmentPlanDetails
  );
  const { loading, error, treatmentPlan } = treatmentPlanDetails;

  const treatmentPlanUpdate = useSelector((state) => state.treatmentPlanUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = treatmentPlanUpdate;

  const treatmentPlanDownloadPdf = useSelector(
    (state) => state.treatmentPlanDownloadPdf
  );
  const {
    loading: loadingDownloadPdf,
    error: errorDownloadPdf,
    pdf,
  } = treatmentPlanDownloadPdf;

  // FUNCTIONS
  const validateServices = (services) => {
    // Check if any service has a quantity of 0
    const isAnyServiceInvalid = services.some(
      (service) => service.quantity === 0
    );

    console.log("isAnyServiceInvalid", isAnyServiceInvalid);

    console.log("isServicesValid", isServicesValid);
    // If any service is invalid, set form validity to false
    setIsServicesValid(!isAnyServiceInvalid);
  };

  // HANDLERS

  const handleAddService = () => {
    setAddServiceModalOpen(!addServiceModalOpen);
  };

  const handleAddPatient = () => {
    setAddPatientModalOpen(!addPatientModalOpen);
  };

  const handleAddCoordinator = () => {
    setAddCoordinatorModalOpen(!addCoordinatorModalOpen);
  };

  const handleServiceOrderChange = (newOrder) => {
    // Update the services with the new order
    setServices(newOrder);
  };

  const downloadTreatmentPlanPdfHandler = (planId) => {
    dispatch(downloadTreatmentPlanPdf(slug, planId, currentLanguage));
  };

  const closeHandler = () => {
    if (hasChanges) {
      setShowUnsavedModal(true);
    } else {
      close();
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // Construct the updated plan object
    const updatedPlan = {
      _id: treatmentPlan._id,
      patient: patient._id,
      employee: employee,
      services: services,
      status: status, // Use the updated status
      coordinator: coordinator.value,
      notes: draftNote,
    };

    try {
      await dispatch(updateTreatmentPlan(slug, updatedPlan));

      // Fetch the latest treatment plan details after a successful update
      dispatch(listTreatmentPlanDetails(slug, planId));
    } catch (error) {}
  };

  const checkStatusOnAddService = (services) => {
    if (services.length === 0) {
      setStatus("draft");
      return;
    } else {
      setStatus("planning");
    }
  };

  const addServiceToList = (selectedService) => {
    // Clone the selectedService to a new object
    const newService = {
      ...selectedService, // Spread to copy properties
      _id: new mongoose.Types.ObjectId(), // ✅ Correct way
      appointment: null, // Set the appointment to null by default
      employee: null, // Set the employee to null by default
      order: services.length + 1, // Set the order based on the current list length
      paid: false, // You can set other default values here
      // Ensure price is copied by value, not by reference if it's an object
      price:
        typeof selectedService.price === "object"
          ? { ...selectedService.price }
          : selectedService.price,
      priceVariations: selectedService.priceVariations,
      totalPrice:
        selectedService.priceVariations === true ? 0 : selectedService.price,
      service: {
        ...selectedService.service, // Deep copy if 'service' is an object
        _id: selectedService.value,
        name: selectedService.label,
        serviceGroup: selectedService.serviceGroup,
        employee: null,
        price: selectedService.price,
        priceVariations: selectedService.priceVariations,
      },
      status: "uncompleted", // Set the initial status as needed
      teeth: [], // Set the initial teeth array as needed
      quantity: selectedService.priceVariations === false ? 1 : 0,
      discountValue: 0,
      discountType: "none",
    };

    // console.log("newService", newService);

    // Add the new service to the list of services
    // setServices((prevServices) => [...prevServices, newService]);
    // setTotalTpPrice(totalTpPrice + newService.totalPrice);

    const updatedServices = [...services, newService];
    setServices(updatedServices);

    // Recalculate total properly
    const newTotalPrice = updatedServices.reduce((total, service) => {
      const quantity = Number(service.quantity || 0);
      const price =
        typeof service.discountedPrice === "number"
          ? service.discountedPrice
          : service.price;
      return total + quantity * price;
    }, 0);
    setTotalTpPrice(newTotalPrice);

    // updateTreatmentPlanStatus([...services, newService], status);

    checkStatusOnAddService([...services, newService]);

    // const updatedServices = [...services, newService];

    //validate
    validateServices(updatedServices);

    if (!isAdvancedMode) {
      setAddServiceModalOpen(false);
    } else {
      toast({
        title: t("toasts.serviceAdded"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // RESET SERVICES STATUS TO UNCOMPLETED
  const resetServicesStatusToUncompleted = () => {
    console.log("RESSETING SERVICES STATUS TO UNCOMPLETED");
    console.log("prevServices", services);

    // setServices((prevServices) => {
    //   const updatedServices = prevServices.map((service) => ({
    //     ...service,
    //     status: "uncompleted",
    //   }));

    //   return updatedServices;
    // });
  };

  // Function to check statuses and update the state
  // Updated checkServiceStatuses function to set the new states
  const checkServiceStatuses = (services) => {
    const completedCount = services.filter(
      (service) => service.status === "completed"
    ).length;
    const uncompletedCount = services.filter(
      (service) => service.status === "uncompleted"
    ).length;

    // Determine if there is exactly one service left to be completed
    const oneLeftToComplete =
      completedCount === services.length - 1 && uncompletedCount === 1;
    // Determine if there is exactly one service left to be uncompleted
    const oneLeftToUncomplete =
      uncompletedCount === services.length - 1 && completedCount === 1;

    // Update state variables

    setOneLeftToComplete(oneLeftToComplete);
    setOneLeftToUncomplete(oneLeftToUncomplete);
  };

  // EDIT AND SAVE SERVICE DETAILS
  const saveEditedService = (updatedService) => {
    console.log("Updated Service:", updatedService);
    const newServices = services.map((service) =>
      service._id === updatedService._id ? updatedService : service
    );

    // Reorder the services based on 'order' attribute
    newServices.sort((a, b) => a.order - b.order);

    // Adjust order for all services
    newServices.forEach((service, index) => {
      service.order = index + 1;
    });

    setServices(newServices);

    // console.log("newServices", newServices);

    // Calculate the total price for all services
    const totalServicesPrice = newServices.reduce((total, service) => {
      const quantity = Number(service.quantity);
      const discountedPrice =
        typeof service.discountedPrice === "number"
          ? service.discountedPrice
          : service.price;
      return total + quantity * discountedPrice;
    }, 0);

    setTotalTpPrice(totalServicesPrice);

    checkServiceStatuses(newServices);
  };

  const checkStatusOnRemoveService = (services) => {
    if (services.length === 0) {
      setStatus("draft");
      return;
    } else {
      setStatus("planning");
    }
  };

  // const removeService = (serviceId) => {
  //   // Filter out the service to be removed and adjust the order of remaining services
  //   const updatedServices = services
  //     .filter((service) => service._id !== serviceId)
  //     .map((service, index) => ({ ...service, order: index + 1 }));

  //   setServices(updatedServices);

  //   // Recalculate the total price after removing a service
  //   const newTotalPrice = updatedServices.reduce((total, service) => {
  //     // Make sure to convert quantity and price to numbers for calculation
  //     const quantity = Number(service.quantity);
  //     const price = Number(service.price);
  //     return total + quantity * price;
  //   }, 0);

  //   setTotalTpPrice(newTotalPrice);

  //   checkStatusOnRemoveService(updatedServices);
  // };
  const removeService = (serviceId) => {
    const updatedServices = services
      .filter((service) => service._id !== serviceId)
      .map((service, index) => ({ ...service, order: index + 1 }));

    setServices(updatedServices);

    // Recalculate the total price using the same logic as in saveEditedService
    const newTotalPrice = updatedServices.reduce((total, service) => {
      const quantity = Number(service.quantity || 0);
      const price =
        typeof service.discountedPrice === "number"
          ? service.discountedPrice
          : service.price;
      return total + quantity * price;
    }, 0);

    setTotalTpPrice(newTotalPrice);
    checkStatusOnRemoveService(updatedServices);
  };

  // refresh treatment plan function
  const refreshTreatmentPlan = () => {
    dispatch(listTreatmentPlanDetails(slug, planId));
  };

  // USEEFFECTS
  useEffect(() => {
    checkServiceStatuses(services);
  }, [services]);

  // New useEffect hook
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoadingDisplay(false);
    }, 300); // CHANGE THIS TO HAVE A LONGER LOADING TIME

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    validateServices(services);
  }, [services]);

  useEffect(() => {
    if (!treatmentPlan || treatmentPlan._id !== planId) {
      dispatch(listTreatmentPlanDetails(slug, planId));
    } else {
      setDate(treatmentPlan.date);
      setPatient(treatmentPlan.patient);
      setEmployee(treatmentPlan.employee);
      setServices(treatmentPlan.services);
      setStatus(treatmentPlan.status);
      setCoordinator(treatmentPlan.coordinator);
      setTotalTpPrice(treatmentPlan.totalPrice);
      setNotes(treatmentPlan.notes || "");
      setDraftNote(treatmentPlan.notes || "");
    }
  }, [dispatch, planId, treatmentPlan, successUpdate]);

  useEffect(() => {
    if (treatmentPlan && treatmentPlan._id === planId) {
      const snapshot = {
        patient: treatmentPlan.patient?._id,
        coordinator:
          treatmentPlan.coordinator?.value || treatmentPlan.coordinator?._id,
        services: JSON.stringify(treatmentPlan.services),
        notes: treatmentPlan.notes || "",
      };
      setInitialPlan(snapshot);
    }
  }, [treatmentPlan]);

  const isAnyServiceDiscounted = useMemo(() => {
    return services.some(
      (service) => service.discountValue > 0 || service.discountType !== "none"
    );
  }, [services]);

  const discountedAmount = useMemo(() => {
    return services.reduce((total, service) => {
      if (service.discountType === "percentage") {
        return (
          total +
          ((service.price * service.discountValue) / 100) *
            (service.quantity || 1)
        );
      } else if (service.discountType === "amount") {
        return total + service.discountValue * (service.quantity || 1);
      }
      return total;
    }, 0);
  }, [services]);

  const reimbursedAmount = useMemo(() => {
    return services.reduce((total, service) => {
      if (
        service.reimbursement?.coverage > 0 &&
        service.reimbursement?.coverageType === "percent"
      ) {
        return (
          total +
          ((service.price * service.reimbursement.coverage) / 100) *
            (service.quantity || 1)
        );
      } else if (
        service.reimbursement?.coverage > 0 &&
        service.reimbursement?.coverageType === "fixed"
      ) {
        return total + service.reimbursement.coverage * (service.quantity || 1);
      }
      return total;
    }, 0);
  }, [services]);

  const isAnyServiceReimbursed = useMemo(() => {
    return services.some((service) => service.reimbursement?.coverage > 0);
  }, [services]);

  const hasChanges = useMemo(() => {
    if (!initialPlan) return false;

    const current = {
      patient: patient?._id,
      coordinator: coordinator?.value || coordinator?._id,
      services: JSON.stringify(services),
      notes: draftNote,
    };

    return (
      current.patient !== initialPlan.patient ||
      current.coordinator !== initialPlan.coordinator ||
      current.services !== initialPlan.services ||
      current.notes !== initialPlan.notes
    );
  }, [patient, coordinator, services, draftNote, initialPlan]);

  const currencySymbol = useCurrencySymbol(currency);

  // LOGS
  // console.log("planId", planId);
  // console.log("treatmentPlan", treatmentPlan);
  // console.log("setSendEmailModalOpen", sendEmailModalOpen);
  // console.log("hasChanges", hasChanges);
  // console.log("services", services);
  // console.log("isAnyServiceDiscounted", isAnyServiceDiscounted);
  // console.log("isAnyServiceReimbursed", isAnyServiceReimbursed);
  // console.log("discountedAmount", discountedAmount);
  // console.log("reimbursedAmount", reimbursedAmount);

  return (
    <>
      {addServiceModalOpen && (
        <AddServiceModal
          addServiceModalOpen={addServiceModalOpen}
          setAddServiceModalOpen={setAddServiceModalOpen}
          addServiceToList={addServiceToList}
          isAdvancedMode={isAdvancedMode}
          toggleAdvancedMode={toggleAdvancedMode}
          currency={currency}
        />
      )}

      {addCoordinatorModalOpen && (
        <AddCoordinatorModal
          addCoordinatorModalOpen={addCoordinatorModalOpen}
          setAddCoordinatorModalOpen={setAddCoordinatorModalOpen}
          setCoordinator={setCoordinator}
        />
      )}

      {sendEmailModalOpen && (
        <SendTreatmentPlanModalNew
          treatmentPlan={treatmentPlan}
          planId={planId}
          planID={treatmentPlan.treatmentPlanID}
          open={sendEmailModalOpen}
          setOpen={setSendEmailModalOpen}
          patient={patient}
          isModalSending={isModalSending}
          setIsModalSending={setIsModalSending}
          fetchUserDetails={refreshTreatmentPlan}
          fetchUnavailable={fetchUnavailable}
          setFetchUnavailable={setFetchUnavailable}
          close={close}
          hasAccessSendToPatient={hasAccessSendToPatient}
        />
      )}

      {showUnsavedModal && (
        <WarningModal
          open={showUnsavedModal}
          setOpen={setShowUnsavedModal}
          warningTitle={t("treatmentPlan.unsavedChangesTitle")}
          warningMessage={t("treatmentPlan.unsavedChangesMessage")}
          warningButtons={true}

          // confirmHandler={confirmStatusChange}
          // cancelHandler={cancelStatusChange}
        />
      )}

      {loading || loadingDisplay ? (
        <Flex bg={whiteMode} align="center" justify="center" w="100%" h="100%">
          <Spinner color={primary} size="lg" />
        </Flex>
      ) : error ? (
        <Flex
          direction="column"
          justify="center"
          align="center"
          margin="0 auto 2rem"
          p="0 0 0rem"
          w="100%"
          h="100%"
          borderRadius="0.75rem"

          // border={isSinglePage ? `1px dashed ${newBorder}` : "none"}
        >
          <Image w="initial" h="4rem" m="1rem 0 0" src={noServices} />
          <Text mt={4} color={textPrimaryMode} fontSize="lg" fontWeight="600">
            {t("treatmentPlan.notFound")}
          </Text>
          <Text mt={1} color={textSecondary} fontSize="sm">
            {t("treatmentPlan.notFoundText")}
          </Text>
          <Button
            mt={4}
            onClick={close}
            borderRadius="10rem"
            fontSize="sm"
            color={textSecondary}
          >
            {t("button.close")}
          </Button>
        </Flex>
      ) : (
        <>
          <Flex
            w="100%"
            h="100%"
            justify="flex-end"
            position="relative"
            bg={whiteMode}
            borderRadius="0rem"
          >
            <Box
              position="relative"
              w="100%"
              maxW="100%"
              borderRadius="0rem"
              h="100%"
            >
              <form
                onSubmit={submitHandler}
                style={{
                  height: "100%",
                }}
              >
                <Flex w="100%" h="100%" direction="column">
                  <Flex
                    justify="space-between"
                    align="center"
                    p={["1.25rem 1.5rem 1.25rem", "1.25rem 2rem 1.25rem"]}
                    borderBottom={`1px solid ${newBorderMode}`}
                    mb="0rem"
                    position="relative"
                    zIndex={90}
                    // bg={greenText}
                    w="100%"
                  >
                    <Flex align="center">
                      {!isMobile && (
                        <IconButton
                          bg={backgroundLightMode}
                          border={`1px solid ${backgroundLightMode}`}
                          color={textSecondary}
                          icon={<FaArrowLeftLong />}
                          borderRadius="10.75rem"
                          fontSize="0.875rem"
                          onClick={closeHandler}
                          mr="1rem"
                          _hover={{
                            bg: primaryAlt,
                            color: white,
                            border: primaryAlt,
                          }}
                        />
                      )}

                      <Flex align="center">
                        <Heading
                          fontSize={["1rem", "1.125rem"]}
                          color={textPrimaryMode}
                          fontWeight="600"
                          mr={4}
                        >
                          {!isMobile && (
                            <>{t("treatmentPlan.treatmentPlan")} - </>
                          )}

                          <Text
                            as="span"
                            color={[textPrimary, textSecondary]}
                            fontWeight={["600", "500"]}
                          >
                            {treatmentPlan.treatmentPlanID}
                          </Text>
                        </Heading>
                        {/* {status} */}
                      </Flex>
                    </Flex>

                    <Flex align="center" justify="flex-end" gap="0.5rem">
                      {treatmentPlan &&
                        treatmentPlan.availablePublic &&
                        treatmentPlan.publicEmailDate !== null && (
                          <Tooltip
                            p="0.5rem 1rem"
                            borderRadius="1rem"
                            placement="top"
                            label={
                              <Flex direction="column">
                                <Flex align="center" gap="0.25rem">
                                  <Text
                                    fontSize="xs"
                                    color={whiteAlt}
                                    fontWeight="500"
                                    textAlign="center"
                                    whiteSpace="nowrap"
                                  >
                                    {t("treatmentPlan.emailSentToPatient")}:
                                  </Text>
                                  <Text
                                    fontSize="xs"
                                    color={white}
                                    fontWeight="500"
                                    textAlign="center"
                                    whiteSpace="nowrap"
                                    textTransform="capitalize"
                                  >
                                    {dayjs(
                                      treatmentPlan.publicEmailDate
                                    ).format("YYYY MMMM D, HH:mm")}
                                  </Text>
                                </Flex>
                                <Flex align="center" gap="0.25rem">
                                  <Text
                                    fontSize="xs"
                                    color={whiteAlt}
                                    fontWeight="500"
                                    textAlign="center"
                                    whiteSpace="nowrap"
                                  >
                                    {t("treatmentPlan.emailSentToPatientBy")}:
                                  </Text>
                                  <Text
                                    fontSize="xs"
                                    color={white}
                                    fontWeight="500"
                                    textAlign="center"
                                    whiteSpace="nowrap"
                                    isTruncated
                                    maxW="220px"
                                  >
                                    {treatmentPlan.emailSentByName &&
                                      treatmentPlan.emailSentByName}
                                    ,{" "}
                                    {treatmentPlan.emailSentByEmail &&
                                      treatmentPlan.emailSentByEmail}
                                  </Text>
                                </Flex>
                              </Flex>
                            }
                          >
                            <Flex
                              bg={color8}
                              align="center"
                              justify="center"
                              w="1.25rem"
                              h="1.25rem"
                              borderRadius="10rem"
                              mr="1rem"
                              flexShrink={0}
                            >
                              <Icon
                                as={FaEnvelope}
                                fontSize="0.6rem"
                                color={white}
                              />
                            </Flex>
                          </Tooltip>
                        )}

                      {treatmentPlan &&
                        treatmentPlan.status === "cancelled" &&
                        treatmentPlan.cancelledFromSharedLinkDate && (
                          <Tooltip
                            p="0.5rem 1rem"
                            borderRadius="1rem"
                            placement="top"
                            label={
                              <Stack gap={0} align="flex-start">
                                <Flex align="center" justify="center">
                                  <Text
                                    fontSize="xs"
                                    color={whiteAlt}
                                    fontWeight="500"
                                    textAlign="center"
                                    mr={1}
                                  >
                                    {t("reason.cancelledBy")}:
                                  </Text>
                                  <Text
                                    isExternal
                                    color={white}
                                    fontWeight="500"
                                    fontSize="xs"
                                    isTruncated
                                    maxW="128px"
                                  >
                                    {t("reason.cancelledByPatient")}
                                  </Text>
                                </Flex>

                                {treatmentPlan.cancelledFromSharedLinkDate !==
                                  null && (
                                  <Flex align="center" justify="center">
                                    <Text
                                      fontSize="xs"
                                      color={whiteAlt}
                                      fontWeight="500"
                                      textAlign="center"
                                      mr={1}
                                    >
                                      {t("reason.cancelledAt")}:
                                    </Text>
                                    <Text
                                      color={white}
                                      fontWeight="500"
                                      fontSize="xs"
                                      isTruncated
                                      maxW="160px"
                                      textTransform="capitalize"
                                    >
                                      {dayjs(
                                        treatmentPlan.cancelledFromSharedLinkDate
                                      ).format("MMMM D, YYYY, HH:mm")}
                                    </Text>
                                  </Flex>
                                )}

                                {treatmentPlan.cancelledReason &&
                                  treatmentPlan.cancelledReason.length > 0 && (
                                    <Flex align="center" justify="center">
                                      <Text
                                        fontSize="xs"
                                        color={whiteAlt}
                                        fontWeight="500"
                                        textAlign="center"
                                        mr={1}
                                      >
                                        {t("reason.cancelledReason")}:
                                      </Text>
                                      <Text
                                        color={white}
                                        fontWeight="500"
                                        fontSize="xs"
                                        isTruncated
                                        maxW="128px"
                                      >
                                        {t(
                                          `reason.${treatmentPlan.cancelledReason}`
                                        )}
                                      </Text>
                                    </Flex>
                                  )}

                                {treatmentPlan.cancelledComment &&
                                  treatmentPlan.cancelledComment.length > 0 && (
                                    <Flex align="center" justify="center">
                                      <Text
                                        fontSize="xs"
                                        color={whiteAlt}
                                        fontWeight="500"
                                        textAlign="center"
                                        mr={1}
                                      >
                                        {t("reason.cancelledComment")}:
                                      </Text>
                                      <Text
                                        color={white}
                                        fontWeight="500"
                                        fontSize="13px"
                                        isTruncated
                                        maxW="128px"
                                      >
                                        {treatmentPlan.cancelledComment}
                                      </Text>
                                    </Flex>
                                  )}
                              </Stack>
                            }
                          >
                            <Flex
                              bg={color6}
                              align="center"
                              justify="center"
                              w="1.25rem"
                              h="1.25rem"
                              borderRadius="10rem"
                              mr="1rem"
                              flexShrink={0}
                            >
                              <Icon
                                as={FaCircleXmark}
                                fontSize="0.6rem"
                                color={white}
                              />
                            </Flex>

                            {/* <Button
                              size="sm"
                              p="0"
                              fontSize="sm"
                              bg="transparent"
                              color={textSecondary}
                              borderRadius="0.875rem"
                              _hover={{
                                bg: "transparent",
                                color: textPrimary,
                              }}
                            >
                              <Icon
                                as={FaCircleXmark}
                                fontSize="0.875rem"
                                color={color6}
                                opacity="0.8"
                              />
                            </Button> */}
                          </Tooltip>
                        )}

                      {treatmentPlan &&
                        treatmentPlan.status === "approved" &&
                        treatmentPlan.approvedFromSharedLinkDate && (
                          <Tooltip
                            p="0.5rem 1rem"
                            borderRadius="1rem"
                            placement="top"
                            label={
                              <Stack gap={0} align="flex-start">
                                <Flex align="center" justify="center">
                                  <Text
                                    fontSize="xs"
                                    color={whiteAlt}
                                    fontWeight="500"
                                    textAlign="center"
                                    mr={1}
                                  >
                                    {t("reason.approvedBy")}:
                                  </Text>
                                  <Text
                                    isExternal
                                    color={white}
                                    fontWeight="500"
                                    fontSize="xs"
                                    isTruncated
                                    maxW="128px"
                                  >
                                    {t("reason.approvedByPatient")}
                                  </Text>
                                </Flex>
                              </Stack>
                            }
                          >
                            <Flex
                              bg={color3}
                              align="center"
                              justify="center"
                              w="1.25rem"
                              h="1.25rem"
                              borderRadius="10rem"
                              mr="1rem"
                              flexShrink={0}
                            >
                              <Icon
                                as={FaCircleCheck}
                                fontSize="0.6rem"
                                color={white}
                              />
                            </Flex>

                            {/* <Button
                              size="sm"
                              p="0"
                              fontSize="sm"
                              bg="transparent"
                              color={textSecondary}
                              borderRadius="0.875rem"
                              _hover={{
                                bg: "transparent",
                                color: textPrimary,
                              }}
                            >
                              <Icon
                                as={FaCircleXmark}
                                fontSize="0.875rem"
                                color={color6}
                                opacity="0.8"
                              />
                            </Button> */}
                          </Tooltip>
                        )}
                      <StatusButtonTreatmentPlanEdit
                        isSmall
                        isUnclickable={status === "draft"}
                        currentStatus={status}
                        options="treatment"
                        onUpdateStatus={setStatus}
                        isServicesValid={isServicesValid}
                        resetServicesStatusToUncompleted={
                          resetServicesStatusToUncompleted
                        }
                      />

                      {isMobile && (
                        <IconButton
                          position="relative"
                          // top="1.5rem"
                          // right="1.5rem"
                          size="sm"
                          bg={backgroundLight}
                          color={textSecondary}
                          onClick={closeHandler}
                          borderRadius="10rem"
                          _hover={{ bg: primaryAlt, color: white }}
                        >
                          <Icon as={FaXmark} />
                        </IconButton>
                      )}
                    </Flex>
                  </Flex>

                  <Flex w="100%" h="100%" direction="column" overflowY="auto">
                    <Flex
                      w="100%"
                      align="center"
                      justify="space-between"
                      p={["1rem 1.5rem", "1rem 2rem"]}
                      gap="1rem"
                      direction={["column", "row"]}
                    >
                      <Flex w={["100%", "50%"]} align="center">
                        <Flex gap="0" direction="column" w="100%">
                          <Text
                            fontSize="0.875rem"
                            fontWeight="600"
                            color={textPrimaryMode}
                            m="0 0 0.5rem"
                          >
                            {t("patient.patient")}
                          </Text>
                          <Flex
                            w="100%"
                            direction="column"
                            border={`1px solid ${newBorderMode}`}
                            p="0.75rem 1rem 1rem"
                            borderRadius="1rem"
                            // gap="0.3rem"
                          >
                            <Flex align="center">
                              <Text
                                fontSize="0.8rem"
                                color={textSecondary}
                                fontWeight="500"
                                mr="0.25rem"
                              >
                                {t("patient.patient")}:{" "}
                              </Text>

                              <UserSelectButton
                                user={patient}
                                onClick={handleAddPatient}
                                isOpen={addPatientModalOpen}
                                isSecondary={false}
                                noUserLabel={t("treatmentPlan.selectPatient")}
                                isLocked
                                isEdit
                              />
                            </Flex>

                            <Flex align="center" m="0.25rem 0 0.4rem">
                              <Text
                                fontSize="0.8rem"
                                color={textSecondary}
                                fontWeight="500"
                              >
                                {t("user.columnEmail")}:
                                <Text
                                  as="span"
                                  fontSize="0.8rem"
                                  color={textPrimaryMode}
                                  fontWeight="500"
                                  ml="0.25rem"
                                >
                                  {patient && patient.email
                                    ? patient.email
                                    : "-"}
                                </Text>
                              </Text>
                            </Flex>

                            <Text
                              fontSize="0.8rem"
                              color={textSecondary}
                              fontWeight="500"
                            >
                              {t("service.phoneNumber")}:
                              <Text
                                as="span"
                                fontSize="0.8rem"
                                color={textPrimaryMode}
                                fontWeight="500"
                                ml="0.25rem"
                              >
                                {patient && patient.phone ? patient.phone : "-"}
                              </Text>
                            </Text>
                          </Flex>
                        </Flex>
                      </Flex>

                      <Flex w={["100%", "50%"]} align="center">
                        <Flex gap="0" direction="column" w="100%">
                          <Text
                            fontSize="0.875rem"
                            fontWeight="600"
                            color={textPrimaryMode}
                            m="0 0 0.5rem"
                          >
                            {t("treatmentPlan.treatmentPlan")}
                          </Text>
                          <Flex
                            w="100%"
                            direction="column"
                            border={`1px solid ${newBorderMode}`}
                            p="0.75rem 1rem 1rem"
                            borderRadius="1rem"
                            // gap="0.3rem"
                          >
                            <Flex align="center">
                              <Text
                                fontSize="0.8rem"
                                color={textSecondary}
                                fontWeight="500"
                                mr="0.25rem"
                              >
                                {t("treatmentPlan.coordinatorShort")}:
                              </Text>

                              <UserSelectButton
                                user={coordinator}
                                onClick={handleAddCoordinator}
                                isOpen={addCoordinatorModalOpen}
                                isSecondary
                                noUserLabel={t(
                                  "treatmentPlan.selectCoordinator"
                                )}
                                isLocked={status === "cancelled"}
                                tpStatus={status}
                              />
                            </Flex>
                            <Flex align="center" m="0.25rem 0 0.4rem">
                              <Text
                                fontSize="0.8rem"
                                color={textSecondary}
                                fontWeight="500"
                              >
                                {t("form.creationDate")}:
                                <Text
                                  as="span"
                                  fontSize="0.8rem"
                                  color={textPrimary}
                                  textTransform="capitalize"
                                  fontWeight="500"
                                  ml="0.25rem"
                                >
                                  {dayjs(treatmentPlan.createdAt).format(
                                    "YYYY MMMM D, HH:mm"
                                  )}
                                </Text>
                              </Text>
                            </Flex>

                            <Text
                              fontSize="0.8rem"
                              color={textSecondary}
                              fontWeight="500"
                            >
                              {t("treatmentPlan.lastUpdatedShort")}:
                              <Text
                                as="span"
                                fontSize="0.8rem"
                                color={textPrimaryMode}
                                textTransform="capitalize"
                                fontWeight="500"
                                ml="0.25rem"
                              >
                                {dayjs(treatmentPlan.updatedAt).format(
                                  "YYYY MMMM D, HH:mm"
                                )}
                              </Text>
                            </Text>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Flex>

                    <Flex
                      w="100%"
                      p={["0.5rem 0rem 6.5rem", "0.5rem 2rem 6.5rem"]}
                      direction="column"
                      // h="100%"
                    >
                      <Flex
                        w="100%"
                        align="center"
                        justify="space-between"
                        m="0 0 0.5rem"
                        p={["0 1.5rem", "initial"]}
                      >
                        <Flex align="center">
                          <Flex align="center" mr="0.5rem">
                            <Text
                              fontSize="0.875rem"
                              fontWeight="600"
                              color={textPrimaryMode}
                              mr="0.25rem"
                            >
                              {t("service.services")}:
                            </Text>

                            {services.length > 0 && (
                              <Text
                                fontWeight="500"
                                color={textPrimaryMode}
                                fontSize="0.875rem"
                              >
                                {currencySymbol} {totalTpPrice}
                              </Text>
                            )}
                          </Flex>

                          {isAnyServiceDiscounted && (
                            <Flex align="center" ml="0.5rem">
                              <Flex
                                align="center"
                                justify="center"
                                textAlign="center"
                                mr={0}
                              >
                                <Icon
                                  as={TbDiscount}
                                  color={primaryAlt}
                                  fontSize="0.8rem"
                                  mr="0.125rem"
                                  position="relative"
                                  top="-1px"
                                />
                              </Flex>
                              <Text
                                fontSize="0.8rem"
                                fontWeight="500"
                                color={textSecondary}
                                mr="0.5rem"
                              >
                                {t("service.discountedAmount")}:{" "}
                                {currencySymbol} {discountedAmount}
                              </Text>
                            </Flex>
                          )}

                          {isAnyServiceReimbursed && (
                            <Flex align="center" ml="0.5rem">
                              <Flex
                                align="center"
                                justify="center"
                                textAlign="center"
                                mr={0}
                              >
                                <Icon
                                  as={MdLocalHospital}
                                  color={primaryAlt}
                                  fontSize="0.8rem"
                                  mr="0.125rem"
                                  position="relative"
                                  top="-1px"
                                />
                              </Flex>
                              <Text
                                fontSize="0.8rem"
                                fontWeight="500"
                                color={textSecondary}
                                mr="0.5rem"
                              >
                                {t("service.reimbursedAmount")}:{" "}
                                {currencySymbol} {reimbursedAmount}
                              </Text>
                            </Flex>
                          )}
                        </Flex>

                        <Flex align="center" justify="flex-end" gap="0.5rem">
                          <IconButton
                            size="sm"
                            fontSize="sm"
                            // borderRadius="1rem"
                            bg={backgroundLightMode}
                            border={`0px solid ${newBorderMode}`}
                            color={textSecondary}
                            borderRadius="10rem"
                            // onClick={() => setIsSimpleView(!isSimpleView)}
                            _hover={{ bg: primaryAlt, color: white }}
                            isDisabled
                          >
                            <Icon as={TbSwitch} fontSize="0.875rem" />
                          </IconButton>{" "}
                          <AddServiceButton
                            tpStatus={status}
                            setAddServiceModalOpen={setAddServiceModalOpen}
                            resetServicesStatusToUncompleted={
                              resetServicesStatusToUncompleted
                            }
                            setStatus={setStatus}
                          />
                        </Flex>
                      </Flex>

                      <Flex
                        w="100%"
                        bg={backgroundLightMode}
                        direction="column"
                        p={["1rem 0rem 0.25rem", "1rem 1rem 0.25rem"]}
                        borderRadius={["0rem", "0.875rem"]}
                        gap="0.75rem"
                        // minH="169px"
                      >
                        {!isMobile ? (
                          <ServiceListNew
                            services={services}
                            updateServiceOrder={handleServiceOrderChange}
                            saveEditedService={saveEditedService}
                            handleAddService={handleAddService}
                            removeService={removeService}
                            isEdit
                            tpStatus={status}
                            setStatus={setStatus}
                            oneLeftToComplete={oneLeftToComplete}
                            oneLeftToUncomplete={oneLeftToUncomplete}
                            resetServicesStatusToUncompleted={
                              resetServicesStatusToUncompleted
                            }
                            currency={currency}
                          />
                        ) : (
                          <ServiceListNewMobile
                            services={services}
                            updateServiceOrder={handleServiceOrderChange}
                            saveEditedService={saveEditedService}
                            handleAddService={handleAddService}
                            removeService={removeService}
                            isEdit
                            tpStatus={status}
                            setStatus={setStatus}
                            oneLeftToComplete={oneLeftToComplete}
                            oneLeftToUncomplete={oneLeftToUncomplete}
                            resetServicesStatusToUncompleted={
                              resetServicesStatusToUncompleted
                            }
                            currency={currency}
                          />
                        )}
                      </Flex>

                      {services.length > 0 && (
                        <Box>
                          <TreatmentPlanPatientNotes
                            notes={notes}
                            setNotes={setNotes}
                            draftNote={draftNote}
                            setDraftNote={setDraftNote}
                          />
                        </Box>
                      )}

                      {/* {services.length > 0 && (
                        <Flex w="100%" m="2rem 0 0" direction="column">
                          <Text
                            fontSize="0.875rem"
                            fontWeight="600"
                            color={textPrimary}
                            mb="1rem"
                          >
                            {t("treatmentPlan.tpNotesPatient")}
                          </Text>

                          <FormControlTextArea
                            label={t("form.notes")}
                            value={notes}
                            placeholder={t("placeholder.tpNotesPatient")}
                            onChange={(e) => {
                              setNotes(e.target.value);
                            }}
                            fontSize="0.8rem"
                            w="100%"
                            h="initial"
                            minH="36px"
                          />
                        </Flex>
                      )} */}
                    </Flex>

                    <Flex
                      align="center"
                      justify="flex-end"
                      position={["relative", "relative"]}
                      bottom={["initial", "2rem"]}
                      right={["initial", "2rem"]}
                      gap="0.5rem"
                      p={["0 1.5rem 8rem", "initial"]}
                      zIndex={9000}
                      direction={["column", "row"]}
                      w={["100%", "auto"]}
                    >
                      <Button
                        bg={whiteMode}
                        border={`1px solid ${newBorderMode}`}
                        color={textSecondary}
                        size="lg"
                        h={["3.5rem", "3rem"]}
                        w={["100%", "auto"]}
                        borderRadius="10rem"
                        _hover={{
                          bg: greenVivid,
                          color: textPrimaryMode,
                        }}
                        onClick={() =>
                          downloadTreatmentPlanPdfHandler(treatmentPlan._id)
                        }
                      >
                        {loadingDownloadPdf ? (
                          <Flex align="center">
                            <Spinner
                              _groupHover={{
                                color: white,
                              }}
                              size="sm"
                              mr={2}
                            />
                            <Text fontSize="sm" fontWeight="500">
                              {t("common.downloading")}
                            </Text>
                          </Flex>
                        ) : (
                          <Icon as={FaFilePdf} fontSize="0.875rem" />
                        )}
                      </Button>

                      <Tooltip
                        bg={buttonRed}
                        color={buttonRedText}
                        padding="0.5rem 1rem"
                        borderRadius="1rem"
                        placement="top"
                        label={
                          <Flex direction="column" align="center">
                            {!isServicesValid && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("treatmentPlan.errorServicesQuantity")}
                              </Text>
                            )}
                            {status === "cancelled" && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("warnings.errorSendingStatusCancelled")}
                              </Text>
                            )}
                          </Flex>
                        }
                        isDisabled={isServicesValid && status !== "cancelled"}
                      >
                        <Button
                          type="button"
                          bg={sendEmailModalOpen ? primaryAlt : whiteMode}
                          size="lg"
                          h={["3.5rem", "3rem"]}
                          w={["100%", "auto"]}
                          color={sendEmailModalOpen ? white : textSecondary}
                          fontSize="sm"
                          borderRadius="10rem"
                          border={`1px solid ${newBorderMode}`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            setSendEmailModalOpen(true);
                          }}
                          // boxShadow={`0px 4px 4px rgba(0, 0, 0, 0.05)`}
                          _hover={{
                            bg: primaryAlt,
                            color: white,
                          }}
                          isDisabled={
                            !isServicesValid || status === "cancelled"
                          }
                        >
                          <Icon as={FaEnvelope} fontSize="0.875rem" />
                          <Text ml="0.5rem">
                            {t("treatmentPlan.sendToPatientButtonLabel")}
                          </Text>
                        </Button>
                      </Tooltip>

                      <Tooltip
                        bg={buttonRed}
                        color={buttonRedText}
                        padding="0.5rem 1rem"
                        borderRadius="1rem"
                        placement="top"
                        label={
                          <Flex direction="column" align="center">
                            {!isPatientSelected && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("treatmentPlan.errorPatient")}
                              </Text>
                            )}
                            {!isCoordinatorSelected && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("treatmentPlan.errorCoordinator")}
                              </Text>
                            )}
                            {!isServicesSelected && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("treatmentPlan.errorServices")}
                              </Text>
                            )}
                            {!isServicesValid && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("treatmentPlan.errorServicesQuantity")}
                              </Text>
                            )}
                            {/* {!hasChanges && (
                              <Text fontSize="xs" fontWeight="500">
                                {t("treatmentPlan.errorNoChanges")}
                              </Text>
                            )} */}
                            {!hasEditAccess && (
                              <>
                                <Text fontSize="xs">
                                  {t("noAccess.treatmentPlanEdit")}
                                </Text>
                                {/* <Text fontSize="xs">
                                  {t("noAccess.textFirst")}{" "}
                                  <Text as="span" color={primaryAlt}>
                                    "{t("noAccess.treatmentPlanEdit")}"
                                  </Text>
                                  . {t("noAccess.textSecond")}{" "}
                                </Text> */}
                              </>
                            )}
                          </Flex>
                        }
                        isDisabled={
                          isServicesSelected &&
                          isServicesValid &&
                          isPatientSelected &&
                          isCoordinatorSelected &&
                          hasEditAccess
                          // hasChanges
                        }
                      >
                        <Button
                          type="submit"
                          minWidth="10rem"
                          bg={textPrimaryMode}
                          size="lg"
                          h={["3.5rem", "3rem"]}
                          w={["100%", "auto"]}
                          color={whiteMode}
                          fontSize="sm"
                          borderRadius="10rem"
                          border={`1px solid ${whiteMode}`}
                          _hover={{
                            bg: primaryAlt,
                            color: white,
                            border: `1px solid ${whiteMode}`,
                          }}
                          isDisabled={
                            !isServicesSelected ||
                            !isServicesValid ||
                            !isPatientSelected ||
                            !isCoordinatorSelected ||
                            !hasEditAccess
                            // !hasChanges
                          }
                          onClick={submitHandler}
                        >
                          {t("button.saveAndExit")}
                        </Button>
                      </Tooltip>
                    </Flex>
                  </Flex>
                </Flex>
              </form>
            </Box>
          </Flex>
        </>
      )}
    </>
  );
};

export default EditTreatmentPlanNewNew;
